import { Link } from "react-router-dom"
import { Home, ShoppingBag, ShoppingCart, User } from "lucide-react"
import { useLocation } from "react-router-dom"
import { cn } from "@/lib/utils"

export default function MobileFooter() {
  const location = useLocation()
  const pathname = location.pathname

  const navItems = [
    { name: "Home", href: "/", icon: Home },
    { name: "Shop", href: "/shop", icon: ShoppingBag },
    { name: "Cart", href: "/cart", icon: ShoppingCart },
    { name: "Account", href: "/dashboard", icon: User },
  ]

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 lg:hidden shadow-lg">
      <nav className="flex justify-around h-16 items-center">
        {navItems.map((item) => {
          const isActive =
            pathname === item.href ||
            (item.href === "/dashboard" && pathname.startsWith("/dashboard"))

          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                "flex flex-col items-center justify-center text-xs font-medium gap-1 transition-colors",
                isActive ? "text-primary" : "text-gray-500 hover:text-primary",
              )}
            >
              <item.icon className={cn("w-5 h-5", isActive ? "text-primary" : "text-gray-500")} />
              <span>{item.name}</span>
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
